import { Action, createReducer } from '@ngrx/store';

export interface SettingsState {
    // app layout
    fixedHeader: boolean;
    fixedNavigation: boolean;
    topNavigation: boolean;

    // global font size
    globalFontSize: string;
}

// here you can configure initial state of your app
// for all your users
export const initialState: SettingsState = {
    // app layout
    fixedHeader: true,
    fixedNavigation: false,
    topNavigation: true,

    // global font size
    globalFontSize: 'md',
};

const settingsReducer = createReducer(initialState);

export function reducer(state: SettingsState, action: Action): SettingsState {
    return settingsReducer(state, action);
}
